import { connect } from 'react-redux'
import { startCropping } from '../../actions/project/crop'
import { IconElement } from '../../components/FrameMenu/index'
import dotProp from "dot-prop-immutable";

const mapStateToProps = (state) => ({
  disabled: !dotProp.get(state, 'project.background.crop.width', false)
})

const mapDispatchToProps = (dispatch, ownState) => ({
  action: () => dispatch(startCropping(ownState.typeOf || false)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconElement)



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/Crop.js